<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-items-center my-3">
      <!-- Search field -->
      <div v-if="!disableSearch">
        <b-form-input
          v-debounce:500="onSearchHandler"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>

      <div class="d-flex align-items-center ml-auto">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2" v-if="!disableChangePerPage">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ totalRows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table">
      <thead>
        <tr>
          <th v-for="(row, rowIndex) in rows" :key="rowIndex">
            <img
              v-if="columnName != row.prop_name && row.enable_sort"
              @click="onSortHandler(row.prop_name, 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer sort-icon"
            />
            <img
              v-else-if="isSort && isAscending && row.enable_sort"
              @click="onSortHandler(row.prop_name, 'desc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer sort-icon"
            />
            <img
              v-else-if="isSort && !isAscending && row.enable_sort"
              @click="onSortHandler(row.prop_name, 'asc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer sort-icon"
            />
            <span class="pr-5">{{ row.name }}</span>
          </th>
          <th class="text-right" v-if="show_status_column">
            <span class="pr-5">{{ $tc("active") }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="data.length > 0">
        <tr v-for="(item, key) in data" :key="key">
          <td v-for="(row, rowIndex) in rows" :key="rowIndex">
            <slot
              :name="row.prop_name"
              :content="item[row.prop_name]"
              :data="item"
              :index="key"
            >
              {{ item[row.prop_name] }}
            </slot>
          </td>

          <td v-if="show_status_column">
            <div class="d-flex align-items-center justify-content-end">
              <StatusDot
                v-if="use_dots === true"
                :status="
                  item[status_prop_name] === status_prop_true_value
                    ? 'active'
                    : 'inactive'
                "
              />
              <label class="ios-switch" v-else>
                <input
                  :checked="item[status_prop_name] === status_prop_true_value"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label>

              <b-dropdown
                right
                variant="edit"
                class="ml-4"
                v-if="show_edit || show_view"
              >
                <b-dropdown-item
                  @click="goToRoute('/master/edit-language', item, 'edit')"
                  v-if="show_edit"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-language', item, 'view')"
                  v-if="show_view"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="data.length == 0">
        <tr>
          <td :colspan="rows.length + 1">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords/>
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="data.length > 0 && !disablePagination"
      v-model="currentPage"
      :total-rows="totalRows"
      @change="onChangePaginationHandler($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
/* 
    row: [{
        prop_name: prop1/prop2, etc,
        name: display name of the column,
        enable_sort: true/false,
    }]

    data: [{
        prop1,
        prop2,
        prop3
    }]

    show_status_column: true/false
    status_prop_name: prop1/prop2,
    status_prop_true_value: "Y"/true
    show_edit: true/false,
    edit_path: "/edit-movie"
    edit_primary_id: prop1/prop2
    show_view: Boolean
    view_path: "/view-movie"
    view_primary_id: prop1/prop2
    use_dots: true/false (use switch or dots for status column)
    onChangePagination: function(perPage, currentPage)
    recordsPerPage: Number
    totalRows: Number
    onSearch: Function(searchText)
    disableSearch: true/false
    disableChangePerPage: true/false
    disablePagination: true/false
*/
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    show_status_column: {
      type: Boolean,
      default: false
    },
    status_prop_name: {
      type: String,
      default: null
    },
    status_prop_true_value: [Boolean, String],
    show_edit: {
      type: Boolean,
      default: false
    },
    show_view: {
      type: Boolean,
      default: false
    },
    edit_path: {
      type: String,
      default: null
    },
    edit_primary_id: {
      type: String,
      default: null
    },
    view_path: {
      type: String,
      default: null
    },
    view_primary_id: {
      type: String,
      default: null
    },
    onSort: {
      type: Function,
      default: () => {}
    },
    use_dots: {
      type: Boolean,
      default: false
    },
    onChangePagination: {
      type: Function,
      default: () => {}
    },
    totalRows: Number,
    recordsPerPage: {
      type: Number,
      default: 10
    },
    onSearch: {
      type: Function,
      default: () => {}
    },
    disableSearch: {
      type: Boolean,
      default: false
    },
    disableChangePerPage: {
      type: Boolean,
      default: false
    },
    disablePagination: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      isSort: false,
      isAscending: true,
      columnName: null,
      orderby: null,

      perPage: 10,
      currentPage: 1,
      selectedvalue: "10",
      searchValue: "",

      viewingnumbers: [
        { name: "All", id: 1 },
        { name: 10, id: 2 },
        { name: 20, id: 3 },
        { name: 30, id: 3 },
        { name: 40, id: 4 },
        { name: 50, id: 5 }
      ]
    };
  },
  watch: {
    totalRows: function(newVal) {
      if (newVal < 10) {
        this.selectedvalue = `${newVal}`;
      } else {
        this.selectedvalue = this.perPage;
      }
    }
  },
  mounted: function() {
    this.perPage =
      this.recordsPerPage !== null || this.recordsPerPage !== undefined
        ? this.recordsPerPage
        : 10;
    this.selectedvalue = this.perPage;
  },
  methods: {
    goToRoute: function(path, item, type) {
      if (type === "edit") {
        if (this.edit_path && this.edit_primary_id) {
          this.$router.push({
            path: this.edit_path,
            query: {
              id: item[this.edit_primary_id]
            }
          });
        } else {
          this.$toasted.show("Please provice a path to edit and the prop name");
        }
      } else if (type === "view") {
        if (this.view_path && this.view_primary_id) {
          this.$router.push({
            path: this.view_path,
            query: {
              id: item[this.edit_primary_id]
            }
          });
        } else {
          this.$toasted.show("Please provice a path to view and the prop name");
        }
      }
    },

    onSortHandler: function(column, sort_type) {
      this.isSort = true;
      this.isAscending = sort_type === "asc" ? true : false;
      this.columnName = column;
      this.orderby = sort_type;
      this.onSort(column, sort_type);
    },

    onChangePaginationHandler: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
      } else {
        this.currentPage = event;
      }

      this.onChangePagination(this.perPage, this.currentPage);
    },

    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.totalRows;
        this.currentPage = 1;
      } else {
        this.perPage = event;
      }
      this.selectedvalue = event;

      this.onChangePagination(this.perPage, this.currentPage);
    },

    onSearchHandler() {
      this.currentPage = 1;
      this.onSearch(this.searchValue);
    }
  }
};
</script>

<style scoped>
.sort-icon {
  width: 15px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/CustomTable.vue